import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../images/YEP - Logo.png";

/**
 * @remarks This is a span element with the YEC Logo
 * for displaying in the top left corner of all the screens.
 * (at the top of the SideNav.)
 * @returns - Png of the YEC logo with White text.
 */
export const Logo = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/redirect");
    }

    return (
        <span className="logo">
            <Grid container justifyContent={'center'} alignItems={"center"}>
                <img src={logo} width={'175vh'} height={'auto'} alt="YEC" onClick={handleClick} />
            </Grid>
        </span>
    );
};
